import {umbracoApi} from "~/utils/axios.util";

export interface ModalContent {
    Text: string
    ClosingButtonText: string
    Title: string
    RedirectToLogo: string
    RedirectFromLogo: string
    RedirectToPlatform: string
    RedirectFromPlatform: string
}

class ModalRepository {
    async get(docType: string, platformId: number, partner: string, redirectUrl: string, redirectFromUrl: string): Promise<ModalContent> {
        const response = await umbracoApi.get<string>("/modal/GetContent", {
            params: {
                docType: docType,
                platform: platformId,
                partner: partner,
                redirectUrl: redirectUrl,
                redirectFromUrl: redirectFromUrl
            }
        });
        
        return JSON.parse(response.data);
    }
}

export default new ModalRepository();